import type { ReactElement, ReactNode } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import { accentColorKeys } from "@onestore/hel/dist/theme/theme.keys"
import type Theme from "@onestore/hel/dist/typings/theme"

export type ColorTagElementProps = {
  children: ReactNode
  typography: Theme.Typography
  value: Theme.AccentColor
}

function ColorTagElement({
  children,
  typography,
  value,
}: ColorTagElementProps): ReactElement<ColorTagElementProps> {
  const isValidColor = accentColorKeys.some((colorKey) => colorKey === value)

  return (
    <TextAtm typography={typography} color={isValidColor ? value : undefined}>
      {children}
    </TextAtm>
  )
}

export default ColorTagElement
